<template>
  <section
    class="vf-o-running-text-strip"
    aria-label="Authentic designer eyewear since 2020"
  >
    <div class="running-text-strip__viewport">
      <div class="running-text-strip__track" aria-hidden="true" inert>
        <span
          v-for="item in marqueeItems"
          :key="item.id"
          class="running-text-strip__item"
        >
          <span class="running-text-strip__label" aria-hidden="true">{{
            item.text
          }}</span>
          <span class="running-text-strip__icon" aria-hidden="true"></span>
        </span>
      </div>
      <div class="running-text-strip__track" aria-hidden="true" inert>
        <span
          v-for="item in marqueeItems"
          :key="`duplicate-${item.id}`"
          class="running-text-strip__item"
        >
          <span class="running-text-strip__label" aria-hidden="true">{{
            item.text
          }}</span>
          <span class="running-text-strip__icon" aria-hidden="true"></span>
        </span>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const baseText = "AUTHENTIC DESIGNER EYEWEAR SINCE 2020";

const marqueeItems = Array.from({ length: 6 }, (_, index) => ({
  id: index,
  text: baseText,
}));
</script>
